import { render, staticRenderFns } from "./HeroImageWithDualCtas.vue?vue&type=template&id=21ada458"
import script from "./HeroImageWithDualCtas.vue?vue&type=script&lang=js"
export * from "./HeroImageWithDualCtas.vue?vue&type=script&lang=js"
import style0 from "./HeroImageWithDualCtas.vue?vue&type=style&index=0&id=21ada458&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkResolver: require('/home/runner/work/marketing/marketing/components/LinkResolver.vue').default})
